export default __webpack_public_path__ + "static/media/cp_geo_cw.e95152b9.svg";